import { format } from "@sorcery/utils/universal/time";

export const PostDate = ({
  dateString,
  className = "",
}: {
  dateString: string;
  className?: string;
}) => {
  if (!dateString) return null;

  return (
    <time dateTime={dateString} className={`text-[grey] ${className}`}>
      {format(new Date(dateString))}
    </time>
  );
};
